var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    style: {
      enableBackground: "new 0 0 23 23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2064B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.2,1.1h-2.1v2.1c0,0.4-0.3,0.7-0.7,0.7c-0.3,0-0.7-0.3-0.7-0.7V1.1H5.7v2.1c0,0.4-0.3,0.7-0.7,0.7 c-0.3,0-0.7-0.3-0.7-0.7V1.1H2.2c-1,0-1.8,0.9-1.8,2.1v2.5h22.1V3.2C22.5,2,21.3,1.1,20.2,1.1z M0.4,7.1v12.6 c0,1.2,0.8,2.1,1.9,2.1h18c1.1,0,2.3-0.9,2.3-2.1V7.1H0.4z M6.6,18.8H4.9c-0.3,0-0.6-0.2-0.6-0.6v-1.7c0-0.3,0.2-0.6,0.6-0.6h1.7 c0.3,0,0.6,0.2,0.6,0.6v1.7C7.1,18.5,6.9,18.8,6.6,18.8L6.6,18.8z M6.6,12.5H4.9c-0.3,0-0.6-0.2-0.6-0.6v-1.7 c0-0.3,0.2-0.6,0.6-0.6h1.7c0.3,0,0.6,0.2,0.6,0.6V12C7.1,12.3,6.9,12.5,6.6,12.5L6.6,12.5z M12.1,18.8h-1.7 c-0.3,0-0.6-0.2-0.6-0.6v-1.7c0-0.3,0.2-0.6,0.6-0.6h1.7c0.3,0,0.6,0.2,0.6,0.6v1.7C12.6,18.5,12.4,18.8,12.1,18.8z M12.1,12.5 h-1.7c-0.3,0-0.6-0.2-0.6-0.6v-1.7c0-0.3,0.2-0.6,0.6-0.6h1.7c0.3,0,0.6,0.2,0.6,0.6V12C12.6,12.3,12.4,12.5,12.1,12.5z M17.6,18.8 h-1.7c-0.3,0-0.6-0.2-0.6-0.6v-1.7c0-0.3,0.2-0.6,0.6-0.6h1.7c0.3,0,0.6,0.2,0.6,0.6v1.7C18.2,18.5,18,18.8,17.6,18.8z M17.6,12.5 h-1.7c-0.3,0-0.6-0.2-0.6-0.6v-1.7c0-0.3,0.2-0.6,0.6-0.6h1.7c0.3,0,0.6,0.2,0.6,0.6V12C18.2,12.3,18,12.5,17.6,12.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar_icon.3d6258d9be186dda997a4927c9964b02.svg";
export { ForwardRef as ReactComponent };